import error from './error'

export default error
